const groupSetting = () => import("./views/groupSetting.vue");
const columnGroup = () => import("./views/columnGroup.vue");
const columnListInGroup = () => import("./views/columnListInGroup.vue");
const contentGroup = () => import("./views/contentGroup.vue");
const contentListInGroup = () => import("./views/contentListInGroup.vue");

export default {
  // 组别设置
  path: "/groupSetting",
  name: "groupSetting",
  component: groupSetting,
  redirect: {
    name: "columnGroup"
  },
  children: [
    {
      path: "columnGroup",
      name: "columnGroup",
      component: columnGroup,
      meta: {
        root: "/inforMan"
      }
    },
    {
      path: "columnListInGroup",
      name: "columnListInGroup",
      component: columnListInGroup,
      meta: {
        root: "/inforMan"
      }
    },
    {
      path: "contentGroup",
      name: "contentGroup",
      component: contentGroup,
      meta: {
        root: "/inforMan"
      }
    },
    {
      path: "contentListInGroup",
      name: "contentListInGroup",
      component: contentListInGroup,
      meta: {
        root: "/inforMan"
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/core/modules/group/router.js